import React from 'react'
import { useParams } from 'react-router-dom';
import { dishes } from '../const/dishes';

const CoursePage = () => {
  //get the id from the url
  const { id } = useParams();
  console.log("id", id);

  const dish = dishes.find((dish) => dish.id === id);
  console.log("id", dish);

  const navigateToHome = () => {
    window.location.href = '/';
  }
  const navigateToPlan = () => {
    window.location.href = '/plan';
  }

  return (

    <div className='text-black min-h-[200px] mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-6 lg:max-w-7xl lg:px-8'>
      <p className='text-gray-700 cursor-pointer' onClick={navigateToHome}>Workouts &gt; {dish?.name}</p>
      <div className='relative cursor-pointer mt-6'>
        <img src="/images/unlock.jpg" className='border-2 border-black rounded-lg max-h-[400px] min-w-[300px] object-cover' />
        <div onClick={navigateToPlan} className='absolute bottom-2 left-2 md:bottom-8 md:left-8 flex w-fit text-white text-center border-2 border-white rounded-full bg-[black] px-4 p-2'>
          Start Trail to unlock
        </div>
      </div>
        <p className='text-2xl font-bold tracking-tight text-gray-900 my-4'>{dish?.name}</p>
        {dish.details}
        <div>
          <button onClick={navigateToPlan} className="mt-6 bg-[#00925D] w-fit px-6 text-white text-sm font-medium rounded-md py-2">Start Trail</button>
        </div>
      </div>
      )
}

      export default CoursePage